"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dynamic from "next/dynamic";
import React, { FC, PropsWithChildren, useMemo } from "react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      gcTime: Infinity,
    },
  },
});

const getReactQueryDevtoolsProduction = () =>
  process.env.NEXT_PUBLIC_TANSTACK_DEVTOOL === "true" &&
  dynamic(
    () => {
      return import(
        /*webpackChunkName: "tanstack-devtools" */ "@tanstack/react-query-devtools/production"
      ).then((mod) => mod.ReactQueryDevtools);
    },
    {
      ssr: false,
    }
  );

const TanstackProvider: FC<PropsWithChildren> = ({ children }) => {
  const ReactQueryDevtoolsProduction = useMemo(() => {
    return getReactQueryDevtoolsProduction();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ReactQueryDevtoolsProduction ? <ReactQueryDevtoolsProduction /> : null}
    </QueryClientProvider>
  );
};

export default TanstackProvider;
